import { Injectable } from '@angular/core';

@Injectable()
export class CareerPlanHistoryService {
  downloadCertificate(certificateUrl) {
    window.open(certificateUrl, '_blank', 'noopener');
  }
}
